module.exports = __webpack_public_path__ + "static/afpa-surveys-logo-726454546bcd06bd5df52f6bc6c372dd.png";